import styled from "styled-components";

export const ControlBarContainer = styled.div`
  display: flex;
  font-size: 12px;
  width: 100%;
  background-color: ${props => props.theme.controlBar.background};
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ControlList = styled.ul`
  display: flex;
  margin: 0;
  list-style: none;
  flex-wrap: wrap;
`;

export const ControlListItem = styled.li`
  display: flex;
  margin-right: 0.25rem;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./app/styled-components/ControlBar.js